import {
  QUOTATION_LINE_TYPES,
  QuotationLineTypes,
} from '@savgroup-front-common/types';

import messages from './messages/quotationLineTypemessages';

export const getQuotationLineTypeMessage = (
  quotationLineType: QuotationLineTypes,
) => {
  switch (quotationLineType) {
    case QUOTATION_LINE_TYPES.ADMINISTRATIVE_FEES:
      return messages.administrativeFees;
    case QUOTATION_LINE_TYPES.DISCOUNT:
      return messages.discount;
    case QUOTATION_LINE_TYPES.KNOWN_AND_UNKNOWN_SERVICE:
      return messages.service;
    case QUOTATION_LINE_TYPES.UNKNOWN_SPARE_PART:
      return messages.unknownSparePart;
    case QUOTATION_LINE_TYPES.SPARE_PARTS:
      return messages.spareSpart;
    case QUOTATION_LINE_TYPES.UNKNOWN_SERVICE:
      return messages.service;
    default:
      throw new Error(`${quotationLineType} is not supported.`);
  }
};
